import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Landing, { LegalPage } from "@/pages/Landing";
import AdminApp from "@/pages/admin/AdminApp";
import StaffApp from "@/pages/portal/StaffApp";

const SignInPage = () => (
  <main className="grid min-h-screen place-items-center bg-[var(--lav)] p-4" data-testid="sign-in-page">
    <div className="grid justify-items-center gap-4">
      <p className="text-sm text-[var(--ink)]/60">OnDose admin · sign in with your email code</p>
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
    </div>
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<Navigate to="/sign-in" replace />} />
            <Route path="/portal/*" element={<StaffApp />} />
            <Route path="/admin/*" element={<>
              <Show when="signed-in"><AdminApp /></Show>
              <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
            </>} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
